export default "__VITE_ASSET__27492486__"